import React from "react";
import { useNavigate } from 'react-router-dom'
//import styles
import style from "../a.module.scss";

const Card = ({data}) => {

    const navigate = useNavigate();

    const projectName = data.projectName
    const projectBy = data.projectBy
    const projectInfo = data.projectInfo
    const skills = data.skills
    const profileId = data.profileId
    const imgSrc = data.imgSrc

    return (
        <div className={style.card}>
        <div className={style.upperSection}>
            <img src={imgSrc} alt="profile-photo"></img>
            <div className={style.titles}>
            <h1>{projectName}</h1>
            <p>By {projectBy}</p>
            </div>
        </div>
        <div className={style.lowerSection}>
            <p>{projectInfo}</p>
            <h1>Required Skills</h1>
            <div className={style.skills}>
            {skills.map((skill, index) => {
                return (
                <div key={index}>
                    <p>{skill}</p>
                </div>
                );
            })}
            </div>
            <h2 onClick={() => navigate(`/${profileId}`)}>View Project</h2>
        </div>
        </div>
  );
};

export default Card;